<template>
    <i
        v-bind:class="this.addLayout()"
        :title="this.title"
        @click="this.handleClick()"
    ></i>
 </template>

<script>

export default {
  name: "QIconButton",
  props: {
    /**
     * callback function
     */
    callback: {
      type: Function,
      required: true,
    },
    disableTimeAfterClicking: {
      type: Number,
      required: false,
      default: 0
    },
    layout: {
        type: String,
        required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isButtonDisabled: false
    }
  },
  methods: {
    addLayout() {
      let layout = this.isButtonDisabled ? this.layout + " w3-disabled" : this.layout;
      return layout;
    },
    disableAfterClick() {
      this.isButtonDisabled = true;
      setTimeout(() => {
        this.isButtonDisabled = false;
      }, this.disableTimeAfterClicking)
    },
    handleClick() {
      if (this.disableTimeAfterClicking > 0 && !this.isButtonDisabled) {
        this.disableAfterClick();
        this.callback();
      }
    }
  },
};
</script>

<style scoped></style>
